import { lazy, Suspense } from 'react';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { Route, Router } from 'react-router-dom';

import store from 'admin/store';
import { antdThemeLight } from 'admin/components/common/Theme';
import { OAUTH, ROOT } from 'admin/constants/routes';
import RouterSwitch from 'admin/components/common/RouterSwitch';
import ErrorBoundary from 'admin/components/common/ErrorBoundary';
import Debugger from 'common/components/Debugger';
import OAuth from 'admin/components/pages/OAuth';
import { translator } from 'utils/translate';
import queryClient from 'admin/queries/client';
import { IS_DEVEL } from 'utils/environment';
import { adminHistory } from 'admin/utils/admin-history';

import App from './App';

translator.source = 'admin';

// Dynamically import React Query Devtools
const ReactQueryDevtools = IS_DEVEL
	? lazy(() => import('@tanstack/react-query-devtools').then(mod => ({ default: mod.ReactQueryDevtools })))
	: null;

ConfigProvider.config({
	holderRender: children => <ConfigProvider theme={antdThemeLight}>{children}</ConfigProvider>,
});

const Root = () => {
	return (
		<Provider store={store}>
			<QueryClientProvider client={queryClient}>
				<ConfigProvider theme={antdThemeLight}>
					<ErrorBoundary>
						<Router history={adminHistory}>
							<RouterSwitch>
								<Route path={OAUTH} component={OAuth} />
								<Route path={ROOT} component={App} />
							</RouterSwitch>
						</Router>
						<Debugger />
					</ErrorBoundary>
				</ConfigProvider>
				{ReactQueryDevtools && (
					<Suspense fallback={null}>
						<ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
					</Suspense>
				)}
			</QueryClientProvider>
		</Provider>
	);
};

export default Root;
